export const ARMES_CHASSE = [
  'Arc',
  'Arbalète',
  'Arme a feu',
  'Poudre noire',
  'Trappe',
];
